import React, { lazy, useCallback, useEffect, useState } from "react";
import {
    TextField,
    Box,
    IconButton,
    InputAdornment } from "../../ui";
import { AddCircle,
    RemoveCircle } from "../../ui/icons";
import { useDispatch,
    useSelector } from "react-redux";
import { useLocation,
    useNavigate } from "react-router-dom";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { snpAxios } from "../../global/api";
import { debounce,
    isEmpty } from "lodash";
import {
  CART_INITIAL_STATE,
  GET_BILL_PRD_DATA,
  getPreUrlAccordingToCart,
  SUCCESS,
  BACKDATEALLOWED,
  DashboardComponent,
  ITEMWISEOFFER,
  DELETEBILLCONFIG,
  printDebugLog,
  CUSTLOYALITYPOINT,
  PARTILBILLAUDIT,
  HOTELSALESCONFIG,
  GENERATEBILL,
  HOMEDELVDETAILS,
  KOTPRINTITEMWISE,
  KOTPRINTNOWISE,
  DELETEREASON,
  GSTFEATURE,
  ASKFORPRINT,
  EPAYMENTSMS,
  InternalBillType,
  getDeviceTypeNew,
  CUSTOMER_DISABLE_IN_BILL,
  WHATSAPPBILLCONFIG
} from "../../../constants/constant";
import { addDataIndb, deleteItemForDb } from "../../global/indexedDB";
import { setBaseCateogoryData, setBaseProductData } from "../../../actions";
import { fetchAllConfigs } from "../../../store/restoBillConfigSlice";
import {
  fetchBillDetails,
  fetchBillDetails1,
  fetchBillItems,
  fetchBillPartialPayDetails,
  fetchBillPaymentDetails,
  updateBillDetails,
} from "../../../store/billDetailsSlice";
import BillItemList from "./BillItemList";
import BillDetailsSection from "./BillDetailsSection";
import BillActionButtons from "./BillActionButtons";
import CustomerDetails from "./CustomerDetails";
import HeaderForm from "./HeaderForm";
import ProductDisplay from "./ProductDisplay";
import RenderCateogoryCard from "../resto/RenderCateogoryCard";
import CategoryCard from "./CategoryCard";
import BillUtilityButtons from "./BillUtilityButtons";
import { useDeviceType } from "../../global/hooks/useDeviceType";

// Lazy-loaded components
const CategoryPanel = lazy(() => import("../resto/RenderCateogoryCard"));
const ProductDisplayPanel = lazy(() => import("./ProductDisplay"));

const SnpBillComp = () => {
  const [catgProductData, setCatgProductData] = useState([]);
  const [filteredCatgProductData, setFilteredCatgProductData] = useState([]);
  const [showProductData, setShowProductData] = useState(false);
  const [loader, showLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { snackbar, dialog } = useSnpUI();
  const { isTablet } = useDeviceType(getDeviceTypeNew);
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );

  const restoBillConfig = useSelector((state) => state.restoBillConfig);

  const storeProductData = useSelector(
    (state) => state.setProductWithCatgReducer.productData
  );
  const { billDetails, billItems, billDetailsFetch } = useSelector(
    (state) => state.bill
  );
  const location = useLocation();
  const [kotCopy, setKotCopy] = useState(billDetails.kotCopies);

  useEffect(() => {
    //
    if (location.state?.tableProps !== null) {
      const tableProps = location.state?.tableProps;
      const billType = location.state?.billType;
      console.log("billType: ", billType);
      console.log("tableProps: ", tableProps);
      dispatch(
        updateBillDetails({
          tableId: tableProps === undefined ? "" : tableProps.id,
          tableNo: tableProps === undefined ? -1 : tableProps.tableNo,
          billNo: tableProps === undefined ? "" : tableProps.billNo,
          tableName: tableProps === undefined ? "" : tableProps.tableName,
          billType: billType !== -1 ? billType : InternalBillType.TakeAway,
        })
      );
    }
  }, [location.state]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const billNo = queryParams.get("bNo");
    printDebugLog("useEffect ", "queryParams: " + queryParams, "billNo: " + billNo);
    if (!isEmpty(billNo)) {
      dispatch(fetchBillDetails1(billNo));
      dispatch(fetchBillItems(billNo));
      dispatch(fetchBillPaymentDetails(billNo));
      dispatch(fetchBillPartialPayDetails(billNo));
    }
  }, [location.search]);

  useEffect(() => {
    const billNo = location.state?.sBillNo;
    console.log("dispatching fetch bill");
    console.log("billno from state: ", location.state?.sBillNo);
    // dispatch(fetchBillDetails(location.state?.sBillNo));
    console.log("kotCopies from redux: ", billDetails.kotCopies);
    console.log("billno 1 from state: ", billNo);
    console.log("kotCopies from redux dp: ", billDetails.kotCopies);
    if (billNo) {
      dispatch(fetchBillDetails1(billNo));
      dispatch(fetchBillItems(billNo));
      dispatch(fetchBillPaymentDetails(billNo));
      dispatch(fetchBillPartialPayDetails(billNo));
    }
    setKotCopy(billDetails.kotCopies);
  }, []);

  const handleRefereshProductData = async () => {
    const firstProduct = filteredCatgProductData[0];
    const catgId = firstProduct?.catgId;

    if (filteredCatgProductData.length && catgId) {
      setShowProductData(false);
      await deleteItemForDb(catgId);
      getProductDataByCatgId(catgId);
      return;
    } else snackbar.show({ message: "Some Internal Problem", color: "red" });
  };
  const updateKotCopies = (add) => {
    printDebugLog("setkotCopies", add, kotCopy);
    if (!billItems.isEmpty()) {
      let copies = 0;
      if (add) {
        copies = kotCopy + 1;
      } else {
        copies = kotCopy === 1 ? 1 : kotCopy - 1;
      }
      console.log("copies: ", copies);

      setKotCopy(copies);
      dispatch(
        updateBillDetails({
          ...billDetails,
          kotCopies: Number(copies),
        })
      );
    } else
      snackbar.show({
        message: "Please add any Item",
        color: "red",
      });
  };

  useEffect(() => {
    // ;
    if (billDetailsFetch.error && billDetailsFetch.error.status === 500) {
      dialog.show({
        title: "",
        iconReq: true,
        negativeReq: true,
        cancelExtra: true,
        requestType: DashboardComponent.BILLDETAILS,
        outSideClickDismiss: false,
        subTitle: "You Are not allowed to Change In Bills.Contact the Owner",
        negativeAction: "Got It!",
        onCancel: () => {
          navigate("/dashboard");
        },
      });
    }
  }, [billDetailsFetch.error]);

  const loadAllConfig = () => {
    const configNames = [
      GSTFEATURE,
      HOTELSALESCONFIG,
      BACKDATEALLOWED,
      ITEMWISEOFFER,
      DELETEBILLCONFIG,
      CUSTLOYALITYPOINT,
      GENERATEBILL,
      HOMEDELVDETAILS,
      KOTPRINTITEMWISE,
      KOTPRINTNOWISE,
      DELETEREASON,
      ASKFORPRINT,
      EPAYMENTSMS,
      PARTILBILLAUDIT,
      CUSTOMER_DISABLE_IN_BILL,
      WHATSAPPBILLCONFIG,
    ];
    dispatch(fetchAllConfigs(configNames));
  };


  useEffect(() => {
    console.log("snpBillComp");
    console.log("productData: ", storeProductData);
    loadAllConfig();
    // On unmount, cancel any pending debounce calls
    // if (debouncedUpdateRef.current) {
    //   debouncedUpdateRef.current.cancel();
    // }
  }, []);
  // const handleCateogoryClick = (category) => {
  //   if (!productDisplayReady) setProductDisplayReady(true);
  //   // Example: Filter products for the selected category
  //   const filtered = []; // fetch or filter logic
  //   setFilteredCatgProductData(filtered);
  //   setShowProductData(true);
  // };

  // const clearFilteredData = () => {
  //   setFilteredCatgProductData([]);
  //   setShowProductData(false);
  // };

  const updateCatgPrdData = (updatedData) => {
    printDebugLog("updateCatgPrdData", updatedData);
    setCatgProductData(updatedData);
  };

  const handleCateogoryClick = async (opt) => {
    printDebugLog("handleCateogoryClick init", new Date().toISOString());
    console.log("opt", opt);
    if (storeProductData.hasOwnProperty(opt.id)) {
      const products = storeProductData[opt.id];
      printDebugLog(
        "handleCateogoryClick dialog false",
        products,
        new Date().toISOString()
      );
      if (products !== undefined) {
        const updatedStockData = await handleStockCountRefresh(products);
        updateCatgPrdData(updatedStockData);
        setFilteredCatgProductData(updatedStockData);
        setShowProductData(true);
      } else getProductDataByCatgId(opt.id);
    } else getProductDataByCatgId(opt.id);
  };

const handleStockCountRefresh = async (products) => {
  const promises = products.map(async (product) => {
    if (!product || !product.stockConcept) return product;

    try {
      let catgUrl =
        storeApiUrl.BACKEND_BASE_URL +
        getPreUrlAccordingToCart(storeActiveShopHash.cartType) +
        `/get-item-live-count/${product.productId}`;
      const res = await snpAxios.get(catgUrl);

      if (res.data.status === SUCCESS) {
        return {
          ...product,
          liveStockCount: res.data.jcJson.liveStockCount,
        };
      }
    } catch (e) {}

    return product;
  });

  return Promise.all(promises);
};
  const createFilteredList = useCallback(
    (e) => {
      let searchChar = e.target.value;
      if (isEmpty(searchChar)) {
        setFilteredCatgProductData([...catgProductData]);
      } else {
        const filteredList = catgProductData.filter((item) =>
          item.name.toLowerCase().includes(searchChar.toLowerCase())
        );
        if (filteredList && filteredList.length > 0) {
          setFilteredCatgProductData(filteredList);
        } else {
          snackbar.show({
            message: searchChar + " is not available in list",
            color: "red",
          });
        }
      }
    },
    [catgProductData]
  );

  const getProductDataByCatgId = async (catgId) => {
    printDebugLog("getProductDataByCatgId catgId => ", catgId);
    showLoader(true);
    let catgUrl =
      storeApiUrl.BACKEND_BASE_URL +
      getPreUrlAccordingToCart(storeActiveShopHash.cartType) +
      GET_BILL_PRD_DATA;
    let data = {
      jcJson: {
        value: CART_INITIAL_STATE.apiToken,
        value_1: catgId,
        shopHash: storeActiveShopHash.id,
      },
    };
    //printLog("getProductDataByCatgId => ",data);
    snpAxios
      .post(catgUrl, data)
      .then((response) => {
        printDebugLog("getProductDataByCatgId => ", response.data);
        showLoader(false);
        if (response.data.status === SUCCESS) {
          console.log(
            "category data fetched from db...",
            response.data.jcJson.value_2
          );

          setFilteredCatgProductData([...response.data.jcJson.value_2]);
          updateCatgPrdDataReceiveFrom(catgId, [
            ...response.data.jcJson.value_2,
          ]);
          setShowProductData(true);
        } else {
          dialog.show({
            negativeReq: true,
            negativeAction: "Home",
            positiveAction: "Add Food Item",
            positiveReq: true,
            outSideClickDismiss: true,
            cancelExtra: true,
            requestType: DashboardComponent.PRODUCTENTRY,
            onConfirmAction: () => {
              navigate("/dashboard/itementry");
            },
            onCancel: () => {
              navigate("/dashboard");
            },
            subTitle: "No Food Item is available! Please add",
          });
        }
      })
      .catch((error) => {
        showLoader(false);
        dialog.show({
          negativeReq: true,
          negativeAction: "Dismiss",
          outSideClickDismiss: true,
          cancelExtra: true,
          requestType: 99,
          //handleSnpCancel: () =>
          //   dispatch(setSnpComponentDetails(INITIAL_SNP_COMPONENT)),
          subTitle: "Internet Connection Lost",
        });
        printDebugLog("Error in fetching product data : ", error);
        //window.location.href = "#/error";
      });
  };
  // const updateCatgPrdDataReceiveFrom = useCallback((catgId, updatedData) => {
  //   const debouncedUpdate = debounce(() => {
  //     printDebugLog("updateCatgPrdDataReceiveFrom", catgId, updatedData);
  //     setCatgProductData(updatedData);
  //     addDataIndb({ id: catgId, value: updatedData });
  //     dispatch(
  //       setBaseProductData({ ...storeProductData, [catgId]: updatedData })
  //     );
  //   }, 100); // Set the debounce delay (100ms)

  //   debouncedUpdate(); // Invoke the debounced function
  //   debouncedUpdateRef.current = debouncedUpdate;
  // }, []);
  const updateCatgPrdDataReceiveFrom = (catgId, updatedData) => {
    printDebugLog("updateCatgPrdDataReceiveFrom", catgId, updatedData);
    setCatgProductData(updatedData);
    addDataIndb({ id: catgId, value: updatedData });
    dispatch(
      setBaseProductData({ ...storeProductData, [catgId]: updatedData })
    );
  };

  // const handleRefereshProductData = async () => {
  //   const firstProduct = filteredCatgProductData[0];
  //   const catgId = firstProduct?.catgId;

  //   if (filteredCatgProductData.length && catgId) {
  //     // handleDialogClose();
  //     await deleteItemForDb(catgId);
  //     getProductDataByCatgId(catgId);
  //     return;
  //   }
  //   snackbar.show({ message: "Some Internal Problem", color: "red" });
  // };
  const clearFilteredData = useCallback(
    debounce(() => {
      setFilteredCatgProductData([]);
      setShowProductData(false);
    }, 100), // Adjust the delay (100ms) as needed
    []
  );

  const renderKotCopies = () => {
    return (
      billDetails.billStatus !== billDetails.isPaid &&
      CART_INITIAL_STATE.kotCopiesAllowed && (
        <div>
          <center>
            <TextField
              id="dkotCopies"
              name="dkotCopies"
              type="number"
              inputMode="numeric"
              disabled
              value={kotCopy || 1}
              variant="outlined"
              helperText="KOT Copies"
              size="small"
              sx={{
                justifyContent: "center",
                alignContent: "center",
                "& .UiInputBase-input": { textAlign: "center" },
                width: { xs: "60%", sm: "30%", md: "20%", lg: "20%" },
                padding: { xs: "5px", sm: "5px", md: "5px", lg: "5px" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={() => updateKotCopies(true)}>
                      <AddCircle color="success" sx={{ fontSize: "2rem" }} />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={() => updateKotCopies(false)}>
                      <RemoveCircle color="warning" sx={{ fontSize: "2rem" }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </center>
        </div>
      )
    );
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: isTablet ? "column" : "row" },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            flex: "1 1 0",
            minWidth: 0,
            maxWidth: "100%",
            width: { xs: "100%", md: isTablet ? "100%" : "auto" },
            boxSizing: "border-box",
            order: { xs: 2, md: isTablet ? 2 : 1 },
            padding: "2px",
          }}
        >
          <HeaderForm />
          <CustomerDetails />
          <BillUtilityButtons />
          <BillItemList />
          <BillDetailsSection />
          {renderKotCopies()}
          <BillActionButtons />
        </Box>

        <Box
          sx={{
            // Keep the category area inside the available billing viewport.
            // On desktop its effective minimum was already 200px in the old MUI
            // layout (CategoryCard minWidth). On tablet/mobile it remains full width.
            flex: { xs: "0 0 0px", md: isTablet ? "0 0 auto" : "0 0 200px" },
            width: { xs: "100%", md: isTablet ? "100%" : "200px" },
            minWidth: { xs: 0, md: isTablet ? 0 : "200px" },
            maxWidth: { xs: "100%", md: isTablet ? "100%" : "400px" },
            boxSizing: "border-box",
            order: { xs: 1, md: isTablet ? 1 : 2 },
            padding: "5px",
          }}
        >
          <CategoryCard handleCateogoryClick={handleCateogoryClick} />
        </Box>
      </Box>

      <ProductDisplay
        open={showProductData}
        products={filteredCatgProductData}
        onClose={clearFilteredData}
        handleRefreshProduct={handleRefereshProductData}
      />
    </>
  );
};

export default SnpBillComp;
